import { render, staticRenderFns } from "./BookmarkPage.vue?vue&type=template&id=514d12b8&scoped=true"
import script from "./BookmarkPage.vue?vue&type=script&lang=js"
export * from "./BookmarkPage.vue?vue&type=script&lang=js"
import style0 from "./BookmarkPage.vue?vue&type=style&index=0&id=514d12b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d12b8",
  null
  
)

export default component.exports